import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  sidebar_collapsed: boolean = false;
  
}